import { Dropdown, MenuProps } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useDialog } from "../../components/dialog/use-dialog";
import { useDeleteTaskMutation } from "../api/api";
import { Message } from "../../../utility/notifications/Message";

interface Props {
	id: number;
	tenantId: number;
}
function TaskActionButton({ id, tenantId }: Props) {
	const [deleteTask] = useDeleteTaskMutation();

	const handleDeleteTask = async (taskId: number) => {
		const result = await Message('Confirm', "Are you sure to delete the task?", 'warning');
		if (result.isConfirmed) {
			await deleteTask({ taskId });
		}
	}

	const { onOpen: openUpdateTaskDialog } = useDialog('biHubTaskUpdate');


	const items: MenuProps['items'] = [
		{
			key: '1',
			label: "Edit",
			onClick: () => openUpdateTaskDialog({ id: id, tenantId: tenantId, }),
		},
		{
			key: '4',
			label: "Delete",
			onClick: () => handleDeleteTask(id),
		}
	];
	return (
		<Dropdown menu={{ items }} placement='bottomRight'>
			<EllipsisOutlined style={{ fontSize: 30 }} />
		</Dropdown>
	);
};

export { TaskActionButton };
